import { ArrowRight, Clock, ShieldCheck } from 'lucide-react'
import { Button } from './ui'

// Tela de abertura, ancorada na promessa do site ("escalar de verdade").
// O diagnostico encontra QUAL gargalo trava a escala (diferencial, adaptativo).
export function Landing({ onStart }) {
  return (
    <div className="w-full animate-fade-slide-in text-center">
      <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-xs font-semibold text-primary">
        Diagnóstico gratuito · Infosaas® Studio
      </span>

      <h1 className="font-display text-3xl font-extrabold leading-tight tracking-tight md:text-5xl">
        Por que o seu negócio <span className="text-primary">ainda não escala de verdade?</span>
      </h1>

      <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
        Tem várias razões pra um negócio travar, e quase ninguém sabe qual é a sua. Em poucas
        perguntas, esse raio-x encontra o gargalo que segura a sua escala e te entrega um plano pra
        destravar.
      </p>

      <div className="mt-8 flex justify-center">
        <Button size="lg" onClick={onStart} className="animate-soft-pulse">
          Descobrir meu gargalo
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-text-tertiary">
        <span className="inline-flex items-center gap-1.5">
          <Clock className="h-3.5 w-3.5" /> Leva 2 minutos
        </span>
        <span className="inline-flex items-center gap-1.5">
          <ShieldCheck className="h-3.5 w-3.5" /> 100% gratuito, sem ligação de vendedor
        </span>
      </div>
    </div>
  )
}
